export default {
  install: () => {
    if (import.meta.env.VITE_APP_ENV != 'production') {
      const script = document.createElement('script')
      script.src = 'https://unpkg.com/eruda@3.0.1/eruda.js'
      script.onload = function () {
        /* eslint-disable @typescript-eslint/no-unused-vars */
        eruda && eruda.init()
      }
      document.body.appendChild(script)
    }
  },
}
